module.exports = __webpack_public_path__ + "static/media/idea1.1936206e.svg";